export default __webpack_public_path__ + "static/media/JobFive1.5e2d2b73.jpg";